import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, memo } from 'react';
import { styled } from '../../../../foundation';
import { PickerBaseIconButton } from '../styles';
import { DayStyle } from './styles';
var _Day = forwardRef(function (props, ref) {
    var children = props.children, disabled = props.disabled, hidden = props.hidden, current = props.current, selected = props.selected, size = props.size, focused = props.focused, day = props.day, rest = __rest(props, ["children", "disabled", "hidden", "current", "selected", "size", "focused", "day"]);
    return (React.createElement(PickerBaseIconButton, __assign({ "aria-pressed": focused, ref: ref, size: size, selected: selected, "data-picker-focused": focused ? '' : undefined, hidden: hidden, "data-test-automation-class": hidden ? 'date-picker-hidden-day' : 'date-picker-day', "data-test-automation-value": children, disabled: disabled }, rest),
        React.createElement(React.Fragment, null, 
        // TODO: that <></> will fix when `RcIconButton` ready
        children)));
});
_Day.displayName = 'RcDay';
_Day.defaultProps = {
    disabled: false,
    hidden: false,
    current: false,
    selected: false,
};
var Day = memo(styled(_Day)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), DayStyle));
export { Day };
var templateObject_1;
